<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />

    <div class="schedule-container">
      <div class="schedule-header">
        <div class="header-content">
          <div class="back-button-section">
            <v-btn class="btn-return" @click="$router.go(-1)">
              <i class="fas fa-arrow-left mr-2"></i>
              Voltar
            </v-btn>
          </div>

          <div class="title-section">
            <h1 class="page-title">
              <i class="fas fa-sync-alt title-icon"></i>
              Configuração de vizualizações de evoluções
            </h1>
          </div>
        </div>
      </div>

      <b-overlay class="mt-5" :show="loading" opacity="0.99">
        <b-card class="card-section mb-3">
          <h6 class="title-pages mb-3">Evoluções</h6>
          <p class="worksansr mb-3 section-description">
            Defina quais evoluções iram aparecer no menu da Equipe
            Multidisciplinar.
          </p>

          <div
            v-for="evolution in evolution_types"
            :key="evolution.id"
            class="evolution-item mb-2"
          >
            <div class="evolution-header d-flex align-items-center px-3 py-2">
              <input
                type="checkbox"
                :id="`ps-${evolution.id}`"
                v-model="evolution.active"
                @change="handleSectionToggle(evolution)"
                class="evolution-checkbox"
              />
              <label
                :for="`ps-${evolution.id}`"
                class="worksansr mb-0 ml-2 flex-grow-1 evolution-label"
              >
                {{ evolution.name }}
              </label>
            </div>
          </div>
        </b-card>

        <errors-messages :errors="errors" />

        <b-row align-h="end" class="mb-4">
          <b-col cols="auto">
            <confirmation-dialog
              headerClass="modal-header"
              message-title="CONFIRMAÇÃO"
              message-body="TEM CERTEZA QUE DESEJA SALVAR?"
              open-class="btn-save"
              open-text="SALVAR"
              openLeftIcon="fa-check"
              @yes="save"
            />
          </b-col>
        </b-row>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import ErrorsMessages from "../templates/Components/ErrorsMessages";
import ConfirmationDialog from "../templates/Components/ConfirmationDialog";
import api from "../services/api";
import toast from "../lib/ToastNotification";

export default {
  name: "ConfigResidentPrint",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    ConfirmationDialog,
  },

  data() {
    return {
      errors: [],

      loading: false,

      evolution_types: [],
    };
  },

  async created() {
    await this.get();
  },

  methods: {
    async get() {
      try {
        this.loading = true;

        const response = await api.get("/rest-home/evolutions/settings");

        const { error, errors, evolution_types } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.evolution_types = evolution_types;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    async save() {
      try {
        this.loading = true;

        let { evolution_types } = this;

        const evolutionTypesToSave = evolution_types.map((s) => ({
          id: s.id,
          type: s.type,
          selected: s.active,
        }));

        const data = {
          evolution_types: evolutionTypesToSave,
        };

        const response = await api.post("/rest-home/evolutions/settings", data);

        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];

          toast(message);

          await this.get();
        }

        this.loading = false;
      } catch (error) {
        console.error(error);
        this.loading = false;
      }
    },

    handleSectionToggle(section) {
      if (!section.selected && section.fields) {
        section.fields.forEach((f) => {
          f.selected = false;
        });
      }
    },
  },
};
</script>

<style scoped>
.schedule-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

.schedule-header {
  padding: 24px 0;
  background: white;
  border-radius: 0 0 24px 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.header-content {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 24px;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

.title-icon {
  color: #0f65b0;
  margin-right: 12px;
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
}

.card-section {
  border: 1px solid #e9ecef;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.section-description {
  font-size: 13px;
  color: #666;
}

.evolution-item {
  border: 1px solid #e9ecef;
  border-radius: 6px;
  overflow: hidden;
  transition: box-shadow 0.15s ease;
}

.evolution-item:hover {
  box-shadow: 0 2px 6px rgba(78, 145, 48, 0.1);
  border-color: #c3ddb8;
}

.evolution-header {
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  transition: background 0.15s ease;
}

.evolution-item:hover .evolution-header {
  background: #f1f8ee;
}

.evolution-checkbox {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: #4e9130;
  flex-shrink: 0;
}

.evolution-label {
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  color: #343a40;
  transition: color 0.15s ease;
}

.evolution-item:hover .evolution-label {
  color: #4e9130;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .header-content {
    grid-template-columns: 1fr;
    gap: 16px;
    text-align: center;
  }

  .page-title {
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .schedule-container {
    padding: 0 16px;
  }

  .schedule-header {
    padding: 20px 0;
    margin-bottom: 24px;
  }

  .header-content {
    padding: 0 16px;
  }

  .page-title {
    font-size: 24px;
  }

  .page-subtitle {
    font-size: 14px;
  }

  .btn-add-modern {
    padding: 10px 20px !important;
    font-size: 14px !important;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 20px;
    flex-direction: column;
    gap: 8px;
  }

  .title-icon {
    margin-right: 0;
  }

  .btn-add-modern {
    padding: 8px 16px !important;
    font-size: 13px !important;
    border-radius: 8px !important;
  }
}

.filters-modern {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(30, 41, 59, 0.06);
  padding: 5px 24px 1px 15px;
  margin: 25px 25px;
  display: flex;
  gap: 25px;
}

.filter-label {
  font-size: 16px;
  font-weight: 500;
  color: #1e293b;
  margin-bottom: 6px;
}

.filter-select >>> .vs__dropdown-toggle:focus,
.filter-select >>> .vs__dropdown-toggle:hover {
  border-color: #0f65b0;
}
</style>